import React from 'react';
import PhoneInput from 'react-phone-input-2';
import { makeStyles } from '@material-ui/core/styles';
import 'react-phone-input-2/lib/material.css';

// Match MUI TextField outlined size="small" height (40px)
const INPUT_HEIGHT = 40;

const useStyles = makeStyles((theme) => ({
  wrapper: {
    '& .react-tel-input': {
      border: `1px solid ${theme.palette.grey[400]}`,
      borderRadius: 4,
      minHeight: INPUT_HEIGHT,
      '&:hover': {
        borderColor: theme.palette.text.primary,
      },
      '&:focus-within': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2,
        margin: -1,
        '& .form-control + div:before': {
          color: theme.palette.primary.main,
        },
        '& .flag-dropdown': {
          borderRightColor: theme.palette.primary.main + ' !important',
        },
      },
    },
    '& .form-control': {
      border: 'none !important',
      borderRadius: '0 4px 4px 0 !important',
      height: `${INPUT_HEIGHT - 2}px !important`,
      minHeight: 'auto !important',
      padding: `0 14px 0 58px !important`,
      fontSize: '14px !important',
      '&:focus': {
        boxShadow: 'none !important',
        outline: 'none',
      },
    },
    '& .flag-dropdown': {
      border: 'none !important',
      borderRight: `1px solid ${theme.palette.grey[400]} !important`,
      borderRadius: '4px 0 0 4px !important',
      minHeight: INPUT_HEIGHT - 2,
    },
    '& .selected-flag': {
      minHeight: INPUT_HEIGHT - 2,
    },
  },
}));

const PhoneInputField = ({ value, handleChange, label = 'Phone' }) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <PhoneInput
        country="us"
        value={value}
        onChange={handleChange}
        specialLabel={label}
        inputProps={{
          name: 'phone',
          required: true,
        }}
        containerStyle={{
          width: '100%',
        }}
        inputStyle={{
          width: '100%',
        }}
      />
    </div>
  );
};

export default PhoneInputField;